export enum ExceptionalOpeningHoursStaleTimeEnum {
  GetExceptionalOpeningHours = 60000,
  GetExceptionalOpeningHoursById = 60000,
}
